import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      title: "Application & Licensing",
      description: "Assistance in Application & Compliances of EPR, E-waste, Plastic, Battery, Tyre & Used Oil",
      link: "assistance-in-application-compliances-of-epr-e-waste-plastic-battery-tyre-used-oil",
      icon: "/images/services/Application & Licensing.jpeg",
      img: "/images/services/Application & Licensing.jpeg"
    },
    {
      title: "Certifications & Registrations",
      description: "We assist businesses in obtaining essential certifications and registrations required for legal compliance, market access, and operational efficiency across various industries and regulatory bodies.",
      link: "chartered-engineering-certification",
      img: "/images/services/certificate.webp"
    },
    {
      title: "Customs & Compliance",
      description: "We provide expert support in navigating customs procedures and ensuring compliance with regulatory requirements for smooth and lawful import-export operations.",
      link: "authorization-from-spcb-for-scrap-import",
      img: "/images/services/custome.jpg"
    }
  ];

  // Animation variants
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 60 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: 'easeOut',
        type: 'spring',
        stiffness: 80
      }
    }
  };

  return (
    <motion.section
      className="py-5 bg-gray-50"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.2 }}
      variants={containerVariants}
    >
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <motion.span
            className="text-green-600 font-medium mb-2 block"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            WHAT WE OFFER
          </motion.span>
          <motion.h2
            className="text-3xl md:text-4xl font-bold"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            Our Services
          </motion.h2>
        </div>

        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={containerVariants}
        >
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-lg shadow-md overflow-hidden transition-transform duration-300 hover:-translate-y-2"
              variants={cardVariants}
            >
              <Link to={`/services#${service.link}`} className="block">
                <div className="relative h-48 bg-gray-200">
                    <img src={service.img} alt="Service " className="w-full h-full object-cover" />
                </div>
                <div className="p-6 mt-8">
                  <h3 className="text-xl font-bold mb-3 hover:text-green-600">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 line-clamp-3">{service.description}</p>
                </div>
              </Link>
            </motion.div>
          ))}
        </motion.div>
        <motion.div
          className="mt-12 text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Link
            to="/services"
            className="inline-block px-6 py-3 text-white bg-green-600 hover:bg-green-700 rounded-lg shadow transition duration-300"
          >
            View All Services
          </Link>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default ServicesSection;